import { render, staticRenderFns } from "./OrderShipmentCommentVisibleForCustomer.vue?vue&type=template&id=b742bc22&"
import script from "./OrderShipmentCommentVisibleForCustomer.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentCommentVisibleForCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports